import cookies from 'js-cookie';

export const Cookie = {
    set: (key = 'key', value = 'value', json = true, days = 14) => {
        let newValue = value;
        if (json) {
            newValue = JSON.stringify(newValue);
        }
        cookies.set(key, newValue, { expires: days });
    },

    get: (key) => {
        const value = cookies.get(key);
        if (!value) {
            return null;
        }
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },

    remove: (key) => {
        cookies.remove(key);
    }
};
